export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  readTime: string;
  publishDate: string;
  content: ArticleSection[];
  faqs: FaqItem[];
  relatedArticles: string[];
}

export interface ArticleSection {
  type: 'heading' | 'paragraph' | 'list';
  level?: number;
  content: string;
  items?: string[];
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'zhengzhuang',
    name: '症状',
    description: '了解龟头责的各种症状表现，帮助早发现、早诊断',
    icon: 'ri-stethoscope-line',
    articleCount: 8,
  },
  {
    slug: 'yuanyin',
    name: '原因',
    description: '深入分析龟头责的致病原因与风险因素',
    icon: 'ri-search-eye-line',
    articleCount: 6,
  },
  {
    slug: 'zhiliao',
    name: '治疗',
    description: '全面解析龟头责的各种治疗方案与康复周期',
    icon: 'ri-heart-pulse-line',
    articleCount: 7,
  },
  {
    slug: 'yufang',
    name: '预防',
    description: '掌握科学的预防方法，降低龟头责复发风险',
    icon: 'ri-shield-check-line',
    articleCount: 5,
  },
  {
    slug: 'yongyao',
    name: '用药',
    description: '详细介绍龟头责常用药物及正确使用方法',
    icon: 'ri-capsule-line',
    articleCount: 6,
  },
];

export const articles: Article[] = [
  {
    slug: 'guitouze-zaoqi-zhengzhuang',
    title: '龟头责的早期症状有哪些？一文读懂识别方法',
    excerpt: '龟头责早期常表现为龟头红肿、瘙痒、分泌物增多等症状。本文详细介绍如何早期识别龟头责，帮助男性朋友及时发现异常并就医。',
    category: '症状',
    categorySlug: 'zhengzhuang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20medical%20illustration%20of%20human%20anatomy%20with%20soft%20warm%20lighting%20on%20cream%20background%2C%20professional%20healthcare%20aesthetic%2C%20editorial%20medical%20photography%20style%20with%20subtle%20gradients%20and%20gentle%20shadows&width=800&height=400&seq=article-symptom-01&orientation=landscape',
    readTime: '6分钟',
    publishDate: '2026-07-15',
    content: [
      { type: 'heading', level: 2, content: '什么是龟头责？' },
      { type: 'paragraph', content: '龟头责，医学上称为龟头炎（Balanitis），是指男性龟头部因各种原因引起的炎症反应。这是一种常见的男性生殖器官疾病，可发生于任何年龄段，但在未行包皮环切术的男性中更为多见。龟头责通常与包皮炎同时存在，合称为龟头包皮炎。' },
      { type: 'heading', level: 2, content: '龟头责的早期典型症状' },
      { type: 'paragraph', content: '龟头责的早期症状因人而异，轻重程度也有所不同。以下是临床上最常见的早期表现，男性朋友应对此保持警惕：' },
      { type: 'heading', level: 3, content: '1. 龟头红肿' },
      { type: 'paragraph', content: '这是龟头责最早且最常见的症状。患者会发现龟头局部或弥漫性发红、肿胀，触碰时有轻微疼痛感。红肿程度可从淡红色到深红色不等，严重时龟头明显肿大，影响正常排尿。' },
      { type: 'heading', level: 3, content: '2. 瘙痒与灼热感' },
      { type: 'paragraph', content: '龟头区域出现难以忍受的瘙痒感，有时伴有灼热、刺痛等不适。这种瘙痒感在夜间或局部温度升高时（如洗澡后）可能加重，严重影响患者的日常生活和睡眠质量。' },
      { type: 'heading', level: 3, content: '3. 异常分泌物增多' },
      { type: 'paragraph', content: '包皮内板和龟头表面可能出现异常分泌物，通常为白色或黄白色奶酪样物质（包皮垢增多），有时伴有异味。感染性龟头责患者可能出现脓性分泌物。' },
      { type: 'heading', level: 3, content: '4. 皮疹与糜烂' },
      { type: 'paragraph', content: '部分患者龟头表面出现红色丘疹、斑丘疹或小水疱，严重者可能出现浅表糜烂或溃疡面，触碰时疼痛明显。' },
      { type: 'heading', level: 3, content: '5. 排尿不适' },
      { type: 'paragraph', content: '当炎症累及尿道外口时，患者可能出现尿频、尿急、尿痛等排尿不适症状，需与尿路感染进行鉴别诊断。' },
      { type: 'heading', level: 2, content: '如何早期识别与自我检查' },
      { type: 'paragraph', content: '建议男性朋友养成定期自我检查的习惯。每天洗澡时注意观察龟头颜色、有无异常分泌物或皮疹。如果发现上述任何症状持续超过24小时，应及时到泌尿外科或男科就诊。' },
      { type: 'paragraph', content: '特别提醒：切勿因羞于启齿而拖延就医。龟头责如果得不到及时治疗，可能导致炎症扩散、包茎加重，甚至引发更严重的并发症。早期诊断和规范治疗是康复的关键。' },
    ],
    faqs: [
      { question: '龟头责会不会自己好？', answer: '轻微的龟头责在保持局部清洁干燥后有可能自行缓解，但不建议等待自愈。未经规范治疗的龟头责容易反复发作或转为慢性，建议出现症状后及时就医。' },
      { question: '龟头责会传染给伴侣吗？', answer: '感染性龟头责（如念珠菌性、滴虫性）可以通过性接触传染给伴侣，建议治疗期间避免性生活或使用安全套。非感染性龟头责（如接触性皮炎）一般不具传染性。' },
      { question: '龟头责和性病有什么区别？', answer: '龟头责是炎症性疾病，而性病（如梅毒、淋病）是特定的病原体感染。两者症状可能有重叠，需由专业医生通过检查进行鉴别诊断。部分性病也可表现为龟头炎症，因此出现症状应尽早就医明确诊断。' },
    ],
    relatedArticles: ['guitouze-bingyin-fenxi', 'guitouze-zhiliao-fangan', 'guitouze-yufang-cuoshi'],
  },
  {
    slug: 'guitouze-bingyin-fenxi',
    title: '龟头责是怎么引起的？五大常见原因深度解析',
    excerpt: '龟头责的病因复杂多样，包括感染因素、卫生习惯、过敏反应等。本文深度剖析五大常见致病原因，帮助您从根本上了解龟头责的发生机制。',
    category: '原因',
    categorySlug: 'yuanyin',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20medical%20research%20concept%20with%20microscope%20and%20clean%20laboratory%20setting%20in%20soft%20warm%20cream%20tones%2C%20minimalist%20scientific%20aesthetic%2C%20editorial%20photography%20with%20gentle%20natural%20light%20and%20clean%20composition&width=800&height=400&seq=article-cause-01&orientation=landscape',
    readTime: '8分钟',
    publishDate: '2026-07-12',
    content: [
      { type: 'heading', level: 2, content: '龟头责的发病机制概述' },
      { type: 'paragraph', content: '龟头责的发生机制较为复杂，通常是多种因素共同作用的结果。龟头部位的皮肤黏膜较为娇嫩，且处于相对封闭、潮湿的环境中，容易受到各种刺激和感染。了解其发病原因，是有效预防和治疗的前提。' },
      { type: 'heading', level: 2, content: '五大常见致病原因' },
      { type: 'heading', level: 3, content: '1. 感染因素（最常见）' },
      { type: 'paragraph', content: '病原微生物感染是导致龟头责的首要原因，主要包括以下几类：' },
      { type: 'list', items: ['念珠菌感染：白色念珠菌是最常见的致病菌，在温暖潮湿环境中易于繁殖，表现为龟头红斑、白色分泌物和剧烈瘙痒。', '细菌感染：金黄色葡萄球菌、链球菌、大肠杆菌等可引起化脓性龟头炎，表现为脓性分泌物和红肿疼痛。', '厌氧菌感染：包皮垢积聚导致厌氧菌过度生长，产生腐败性分泌物和异味。', '滴虫感染：阴道毛滴虫可通过性接触传播，引起龟头糜烂和瘙痒。', '病毒因素：单纯疱疹病毒可导致疱疹性龟头炎，表现为成簇水疱。'] },
      { type: 'heading', level: 3, content: '2. 不良卫生习惯' },
      { type: 'paragraph', content: '个人卫生习惯与龟头责的发生密切相关。包皮过长或包茎的男性，包皮垢容易在包皮内板积聚，形成适合细菌和真菌生长的环境。长期不清洗或清洗不当，会显著增加龟头责的风险。另一方面，过度清洗或使用刺激性强的清洁产品，也可能破坏龟头部正常的微生态环境，反而诱发炎症。' },
      { type: 'heading', level: 3, content: '3. 过敏反应与化学刺激' },
      { type: 'paragraph', content: '部分男性对某些物质存在过敏反应，接触后可引发接触性龟头皮炎。常见的致敏物质包括：避孕套乳胶成分、阴道杀精剂、含香精的沐浴露或肥皂、洗衣液残留的内裤、某些外用药物等。这类龟头责的特点是接触致敏物后迅速发生，去除刺激后较快缓解。' },
      { type: 'heading', level: 3, content: '4. 全身性疾病因素' },
      { type: 'paragraph', content: '某些全身性疾病可增加龟头责的发病风险。糖尿病患者由于尿液中糖分含量升高，为微生物繁殖提供了有利条件，是龟头责的高危人群。此外，免疫功能低下者（如HIV感染者、长期使用免疫抑制剂者）也更容易发生龟头责，且症状往往更重、更难治疗。' },
      { type: 'heading', level: 3, content: '5. 机械性损伤' },
      { type: 'paragraph', content: '性生活过于剧烈、手淫方式不当、衣物摩擦等因素可导致龟头局部微小损伤，破坏皮肤黏膜屏障，为病原微生物入侵创造条件。反复的机械性刺激还可能导致慢性龟头炎，迁延不愈。' },
      { type: 'heading', level: 2, content: '高危人群提示' },
      { type: 'paragraph', content: '以下人群应特别警惕龟头责的发生：包皮过长或包茎未行手术者、糖尿病患者（尤其是血糖控制不佳者）、免疫功能低下者、近期使用广谱抗生素者（破坏正常菌群平衡）、有多个性伴侣且未采取保护措施者。建议高危人群加强日常预防措施，定期进行生殖健康检查。' },
    ],
    faqs: [
      { question: '包皮过长一定会得龟头责吗？', answer: '包皮过长只是增加了龟头责的风险，并非一定会发病。只要保持良好的个人卫生习惯，每天翻开包皮清洗并保持干燥，即使包皮过长也可以有效预防龟头责。' },
      { question: '糖尿病和龟头责有什么关系？', answer: '糖尿病患者尿液中含糖量较高，为念珠菌等微生物生长提供了良好环境。血糖控制不佳的糖尿病患者反复发作龟头责的风险显著升高，控制好血糖是预防的关键。' },
      { question: '过敏引起的龟头责如何判断？', answer: '过敏性龟头责通常在使用某种新产品（如新避孕套、新沐浴露）后短时间内出现，停用可疑致敏物后症状较快缓解。如需明确诊断，可到皮肤科进行斑贴试验。' },
    ],
    relatedArticles: ['guitouze-zaoqi-zhengzhuang', 'guitouze-yufang-cuoshi', 'guitouze-changyong-yaowu'],
  },
  {
    slug: 'guitouze-zhiliao-fangan',
    title: '龟头责的治疗方法全解析：从药物到手术',
    excerpt: '龟头责的治疗方案因病因和严重程度而异，从局部用药到口服药物再到手术治疗。本文全面梳理各种治疗方法的适应症、疗程及注意事项。',
    category: '治疗',
    categorySlug: 'zhiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20treatment%20concept%20with%20soft%20warm%20cream%20background%2C%20minimalist%20healthcare%20aesthetic%2C%20professional%20clinical%20setting%20with%20gentle%20natural%20lighting%20and%20subtle%20medical%20elements&width=800&height=400&seq=article-treatment-01&orientation=landscape',
    readTime: '10分钟',
    publishDate: '2026-07-10',
    content: [
      { type: 'heading', level: 2, content: '龟头责的治疗原则' },
      { type: 'paragraph', content: '龟头责的治疗应遵循"明确病因、针对性治疗、综合管理"的原则。治疗前应通过临床表现、病原学检查等手段明确病因类型，然后选择最适合的治疗方案。同时注意局部护理和生活方式调整，以达到最佳治疗效果并预防复发。' },
      { type: 'heading', level: 2, content: '保守治疗' },
      { type: 'heading', level: 3, content: '1. 局部清洁护理' },
      { type: 'paragraph', content: '这是最基础也是最重要的治疗措施。每天用温水（不宜过热）清洗龟头和包皮内侧，清洗后用干净柔软的毛巾轻轻吸干水分。建议使用无刺激性、无香精的中性清洁产品，或不使用任何清洁剂仅用清水清洗。保持局部清洁干燥，有助于减轻炎症和控制感染。' },
      { type: 'heading', level: 3, content: '2. 局部药物治疗' },
      { type: 'paragraph', content: '根据病因不同，局部用药方案也有所区别：' },
      { type: 'list', items: ['抗真菌药膏：适用于念珠菌性龟头责，常用药物包括克霉唑乳膏、咪康唑乳膏、制霉菌素软膏等。通常每日涂抹1-2次，疗程1-2周。涂抹前应先清洗患处并擦干。', '抗生素软膏：适用于细菌性龟头责，常用药物包括莫匹罗星软膏（百多邦）、夫西地酸乳膏等。每日2-3次，疗程一般为5-7天。', '激素类药膏：适用于过敏性/接触性龟头责，常用弱效糖皮质激素如1%氢化可的松乳膏。可快速缓解红肿瘙痒，但不宜长期使用（通常不超过1周），以免导致皮肤萎缩。', '复合制剂：部分药物同时含有抗真菌和抗炎成分，适用于诊断不明确但急需缓解症状的情况。'] },
      { type: 'heading', level: 2, content: '口服药物治疗' },
      { type: 'paragraph', content: '当局部治疗效果不佳、症状较重或反复发作时，需考虑口服药物治疗：' },
      { type: 'list', items: ['口服抗真菌药：如氟康唑（大扶康）单次口服150mg，对于顽固性念珠菌感染效果良好。复发者可考虑每周一次维持治疗。', '口服抗生素：适用于中重度细菌感染，根据病原菌药敏结果选择敏感抗生素，如头孢类、大环内酯类等。疗程通常为5-7天。', '口服抗组胺药：对于过敏性龟头责伴有严重瘙痒者，可口服氯雷他定、西替利嗪等抗组胺药止痒。', '降糖治疗：糖尿病患者需积极控制血糖，这是治疗和预防复发的关键。'] },
      { type: 'heading', level: 2, content: '手术治疗' },
      { type: 'heading', level: 3, content: '包皮环切术' },
      { type: 'paragraph', content: '对于包皮过长或包茎且反复发作龟头责的患者，包皮环切术是最有效的根治方法。手术切除多余的包皮后，龟头可保持外露干燥状态，消除了包皮垢积聚的环境，复发率可降低80%以上。' },
      { type: 'paragraph', content: '手术时机通常选择在急性炎症完全消退后进行。术后需注意伤口护理，避免感染，通常1-2周后拆线，4-6周后完全恢复。' },
      { type: 'heading', level: 2, content: '中医治疗' },
      { type: 'paragraph', content: '中医将龟头责归于"阴头疮""下疳"范畴，认为与湿热下注、热毒蕴结有关。治疗以清热利湿、解毒消肿为原则，外用药如苦参、黄柏、地肤子等煎汤外洗，内服药如龙胆泻肝汤加减。中西医结合治疗可获得更好的整体疗效。' },
      { type: 'heading', level: 2, content: '治疗注意事项' },
      { type: 'list', items: ['切勿自行购买药物随意使用，尤其是含有强效激素的复方药膏，错误使用可能掩盖病情或导致不良反应。', '治疗期间建议暂停性生活，直至症状完全消失。', '如伴有包茎且发生嵌顿（包皮卡住无法复位），属急症，需立即就医。', '完成全程治疗，不要症状一好转就停药，否则容易导致复发或产生耐药。', '治疗结束后建议复查，确认病原菌已清除。'] },
    ],
    faqs: [
      { question: '龟头责治疗一般需要多长时间？', answer: '轻度的念珠菌性龟头责局部用药1-2周即可治愈。细菌感染通常需5-7天。慢性或反复发作的患者可能需要2-4周的全程治疗。血糖控制不佳的糖尿病患者治疗周期可能更长。' },
      { question: '什么情况下需要做包皮手术？', answer: '以下情况建议考虑包皮环切术：1）包茎者；2）包皮过长且反复发作龟头责（一年发作3次以上）；3）包皮过长伴有反复尿路感染；4）发生过包皮嵌顿者。手术应在炎症完全消退后进行。' },
      { question: '治疗期间饮食需要注意什么？', answer: '建议清淡饮食，避免辛辣刺激性食物（辣椒、花椒、大蒜等）、酒精及高糖食物。多食用新鲜蔬菜水果，保持大便通畅。糖尿病患者应严格控制碳水化合物摄入，保持血糖稳定。' },
    ],
    relatedArticles: ['guitouze-changyong-yaowu', 'guitouze-yufang-cuoshi', 'guitouze-bingyin-fenxi'],
  },
  {
    slug: 'guitouze-yufang-cuoshi',
    title: '如何预防龟头责复发？科学有效的日常防护指南',
    excerpt: '龟头责的预防胜于治疗。本文从日常清洁、生活习惯、饮食调整等多个维度，为您提供一套科学全面的龟头责预防方案，有效降低复发风险。',
    category: '预防',
    categorySlug: 'yufang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20wellness%20and%20healthy%20lifestyle%20concept%20with%20soft%20warm%20cream%20background%2C%20fresh%20and%20natural%20aesthetic%2C%20editorial%20photography%20style%20with%20gentle%20sunlight%20and%20calm%20serene%20atmosphere&width=800&height=400&seq=article-prevention-01&orientation=landscape',
    readTime: '7分钟',
    publishDate: '2026-07-08',
    content: [
      { type: 'heading', level: 2, content: '为什么预防比治疗更重要？' },
      { type: 'paragraph', content: '龟头责是一种容易反复发作的疾病。据统计，未经规范预防的患者一年内复发率可达30%-50%。反复发作不仅影响生活质量，还可能导致慢性炎症、包皮瘢痕形成，甚至增加龟头癌的风险。因此，建立科学的预防体系至关重要。' },
      { type: 'heading', level: 2, content: '日常清洁六步法' },
      { type: 'paragraph', content: '掌握正确的日常清洁方法，是预防龟头责的第一道防线：' },
      { type: 'list', items: ['第一步：每天至少清洗一次（睡前为佳），运动出汗后应及时清洗。', '第二步：使用温水（37-40℃），水温过高会刺激皮肤，过低则清洁效果不佳。', '第三步：将包皮完全上翻，充分暴露龟头和冠状沟。包茎者不可强行上翻。', '第四步：使用无香精、无刺激的中性清洁产品或不使用清洁剂，仅用清水冲洗。', '第五步：用流动清水彻底冲洗干净，确保无清洁剂残留。', '第六步：用干净、柔软的专用毛巾轻轻吸干水分，切勿用力搓擦。注意毛巾应勤换洗，保持清洁。'] },
      { type: 'heading', level: 2, content: '生活习惯调整' },
      { type: 'heading', level: 3, content: '内裤选择与更换' },
      { type: 'paragraph', content: '选择宽松透气的纯棉内裤，避免化纤材质和过紧的内裤。每天更换内裤，清洗后在阳光下充分晾晒。避免久坐，每隔1-2小时起身活动，促进局部通风散热。' },
      { type: 'heading', level: 3, content: '性生活卫生' },
      { type: 'paragraph', content: '性生活前后均应清洗外生殖器。避免不洁性交，建议使用安全套。如果伴侣患有阴道炎（如念珠菌性阴道炎），应双方同时治疗，否则容易交叉感染，导致龟头责反复发作。' },
      { type: 'heading', level: 3, content: '避免不当刺激' },
      { type: 'paragraph', content: '避免使用含香精、酒精的湿巾或喷雾。手淫时动作应轻柔，避免造成微小损伤。不要自行使用药皂或消毒液清洗，这些产品会破坏局部正常菌群。' },
      { type: 'heading', level: 2, content: '饮食调理建议' },
      { type: 'paragraph', content: '合理的饮食有助于维持良好的免疫功能和局部环境：' },
      { type: 'list', items: ['多吃富含维生素C的食物（柑橘、猕猴桃、番茄），增强免疫力。', '适量摄入含锌食物（牡蛎、瘦肉、坚果），促进组织修复。', '多饮水，稀释尿液，减少尿液中有害物质对龟头的刺激。', '限制高糖食物和精制碳水化合物，减少念珠菌生长的"养料"。', '限制辛辣刺激性食物和酒精，这些食物可能加重局部炎症反应。', '糖尿病患者应严格遵循糖尿病饮食原则，保持血糖平稳。'] },
      { type: 'heading', level: 2, content: '定期检查与随访' },
      { type: 'paragraph', content: '建议每年进行一次男性生殖健康检查。糖尿病患者应每半年检查一次。如果发现龟头出现任何异常变化（颜色改变、新发皮疹、异常分泌物等），应及时就诊，不要拖延。对于反复发作者，应与医生建立长期随访关系，制定个性化预防方案。' },
    ],
    faqs: [
      { question: '使用肥皂清洗龟头可以吗？', answer: '不建议使用普通肥皂或沐浴露清洗龟头。这些产品多为碱性，会破坏龟头部正常的弱酸性环境，反而增加感染风险。建议使用温和的、无香精的中性清洁产品，或用清水清洗即可。' },
      { question: '包皮手术能彻底预防龟头责吗？', answer: '包皮环切术可以显著降低龟头责的复发率（降低80%以上），但并非100%杜绝。术后仍需保持良好的卫生习惯和健康的生活方式，才能最大程度降低风险。' },
      { question: '性伴侣需要同时治疗吗？', answer: '如果确诊为念珠菌或滴虫等可经性接触传播的病原体，建议性伴侣同时接受检查和治疗。否则容易出现"乒乓球效应"——一方治愈后又被另一方再次传染，导致反复发作。' },
    ],
    relatedArticles: ['guitouze-zhiliao-fangan', 'guitouze-bingyin-fenxi', 'guitouze-yinshi-tiaoli'],
  },
  {
    slug: 'guitouze-changyong-yaowu',
    title: '龟头责常用药物大盘点：如何正确选择与使用',
    excerpt: '面对药店琳琅满目的药物，龟头责患者该如何选择？本文详细介绍龟头责各类常用药物的适应症、用法用量及注意事项，帮您安全用药。',
    category: '用药',
    categorySlug: 'yongyao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20pharmaceutical%20and%20medical%20concept%20with%20soft%20warm%20cream%20background%2C%20professional%20healthcare%20product%20aesthetic%2C%20editorial%20photography%20with%20gentle%20lighting%20and%20clean%20composition&width=800&height=400&seq=article-medicine-01&orientation=landscape',
    readTime: '9分钟',
    publishDate: '2026-07-05',
    content: [
      { type: 'heading', level: 2, content: '用药前的重要提示' },
      { type: 'paragraph', content: '本文介绍的所有药物仅供参考，不构成处方建议。龟头责的病因多样，不同类型的龟头责需要不同的药物治疗。错误的用药不仅无效，还可能延误病情或导致不良反应。用药前应到医院明确诊断，在医生指导下选择最适合您的药物。' },
      { type: 'heading', level: 2, content: '抗真菌类药物' },
      { type: 'heading', level: 3, content: '克霉唑乳膏（Clotrimazole）' },
      { type: 'paragraph', content: '克霉唑是广谱抗真菌药物，是治疗念珠菌性龟头责的一线用药。用法：清洗擦干患处后，取适量药膏薄薄涂抹一层，轻轻按摩至吸收，每日1-2次。常规疗程为1-2周。该药耐受性良好，少数患者可能出现局部轻微烧灼感。' },
      { type: 'heading', level: 3, content: '咪康唑乳膏（Miconazole）' },
      { type: 'paragraph', content: '咪康唑对念珠菌和部分革兰阳性菌均有效果，适用于混合感染可能的患者。用法与克霉唑类似，每日2次涂抹患处。疗程通常为7-14天。注意该药可能影响乳胶避孕套的完整性，治疗期间建议使用其他避孕方式。' },
      { type: 'heading', level: 3, content: '氟康唑胶囊（Fluconazole）' },
      { type: 'paragraph', content: '口服抗真菌药，用于局部治疗效果不佳或反复发作的念珠菌性龟头责。标准用法为150mg单次口服。复发者可每周服用150mg作为预防性治疗。肝功能异常者慎用，用药期间避免饮酒。' },
      { type: 'heading', level: 2, content: '抗生素类药物' },
      { type: 'heading', level: 3, content: '莫匹罗星软膏（Mupirocin）' },
      { type: 'paragraph', content: '商品名百多邦，对金黄色葡萄球菌和链球菌有良好抗菌活性。适用于细菌性龟头责。每日2-3次涂抹患处，疗程5-7天。该药不宜长期大面积使用，以免产生耐药。' },
      { type: 'heading', level: 3, content: '夫西地酸乳膏（Fusidic Acid）' },
      { type: 'paragraph', content: '对葡萄球菌属高度敏感，是治疗浅表细菌感染的常用药物。每日2-3次，疗程一般不超过7天。该药穿透性好，疗效确切，不良反应少见。' },
      { type: 'heading', level: 2, content: '抗炎止痒类药物' },
      { type: 'heading', level: 3, content: '氢化可的松乳膏（Hydrocortisone 1%）' },
      { type: 'paragraph', content: '弱效糖皮质激素，适用于过敏性/接触性龟头责的短期治疗。可快速缓解红肿、瘙痒。但使用时间不应超过5-7天，不宜用于感染性龟头责（除非联合抗感染药物），否则可能加重感染。' },
      { type: 'heading', level: 2, content: '中成药外用制剂' },
      { type: 'paragraph', content: '部分中成药外用制剂在龟头责的辅助治疗中也有应用。如复方黄柏液（清热燥湿、消肿止痛）、康复新液（促进创面愈合）等。中成药制剂通常刺激性较小，适合敏感皮肤人群使用，但起效速度可能慢于西药制剂。' },
      { type: 'heading', level: 2, content: '安全用药注意事项' },
      { type: 'list', items: ['明确诊断后用药：不同病因的龟头责用药完全不同，必须先明确诊断。', '遵医嘱完成疗程：症状好转不等于痊愈，提前停药容易导致复发。', '警惕药物过敏：首次使用任何外用药物时，先在小面积皮肤上测试。', '避免长期使用激素药膏：糖皮质激素类药膏连续使用不宜超过1周。', '注意药物相互作用：口服抗真菌药与多种药物存在相互作用，就诊时告知医生正在服用的所有药物。', '观察不良反应：用药期间如出现症状加重、皮疹扩散等异常情况，立即停药就医。', '儿童用药需谨慎：儿童龟头责的用药剂量和种类需在儿科医生指导下进行。'] },
    ],
    faqs: [
      { question: '可以自己在药店买药治疗吗？', answer: '不建议。虽然部分外用药是非处方药（OTC），但龟头责病因多样，需先明确诊断。错误用药可能导致治疗失败、病情加重或药物不良反应。首次发作者一定要先就医，明确诊断后再按医嘱用药。' },
      { question: '某某药膏涂了三天没效果怎么办？', answer: '用药3天无明显改善，可能的原因包括：诊断有误（病因非所用药物的目标病原体）、药物不敏感（耐药）、存在混合感染等。此时不应自行更换药物或加量，而应及时复诊，让医生重新评估治疗方案。' },
      { question: '孕妇能用这些药吗？', answer: '本文所述药物主要针对男性患者。如果孕妇本身有念珠菌感染需要治疗，应在产科医生指导下用药，不可自行使用本文列出的药物。部分抗真菌药在孕期使用安全性数据有限。' },
    ],
    relatedArticles: ['guitouze-zhiliao-fangan', 'guitouze-yufang-cuoshi', 'guitouze-zaoqi-zhengzhuang'],
  },
  {
    slug: 'guitouze-yinshi-tiaoli',
    title: '龟头责的饮食调理指南：吃对食物加速康复',
    excerpt: '科学的饮食调理可以有效辅助龟头责的治疗和预防。本文从中医食疗和现代营养学角度，为您推荐有助于康复的食物和应避免的饮食禁忌。',
    category: '治疗',
    categorySlug: 'zhiliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fresh%20healthy%20food%20and%20nutrition%20concept%20on%20soft%20warm%20cream%20background%2C%20minimalist%20wellness%20aesthetic%2C%20editorial%20food%20photography%20with%20gentle%20natural%20lighting%20and%20clean%20organic%20composition&width=800&height=400&seq=article-diet-01&orientation=landscape',
    readTime: '5分钟',
    publishDate: '2026-07-02',
    content: [
      { type: 'heading', level: 2, content: '饮食与龟头责的关系' },
      { type: 'paragraph', content: '虽然饮食调理不能替代药物治疗，但科学的饮食可以帮助增强免疫功能、改善局部微环境、减轻炎症反应，对龟头责的康复和预防复发具有重要意义。尤其对于糖尿病相关龟头责和反复发作的念珠菌感染，饮食控制更是关键环节。' },
      { type: 'heading', level: 2, content: '推荐食物清单' },
      { type: 'heading', level: 3, content: '富含维生素C的食物' },
      { type: 'paragraph', content: '维生素C具有抗氧化和增强免疫力的作用。推荐食物：鲜橙、猕猴桃、草莓、番茄、青椒、西兰花。每日保证摄入足量新鲜蔬果。' },
      { type: 'heading', level: 3, content: '含锌丰富的食物' },
      { type: 'paragraph', content: '锌是维持免疫功能和促进组织修复的重要微量元素。推荐食物：牡蛎、瘦牛肉、猪肝、南瓜籽、松子、鸡蛋黄。' },
      { type: 'heading', level: 3, content: '清热解毒类食材（中医角度）' },
      { type: 'paragraph', content: '中医认为龟头责与湿热有关，建议多食用清热解毒、利湿的食物。推荐：绿豆汤、冬瓜、苦瓜、薏仁、马齿苋、莲藕。' },
      { type: 'heading', level: 2, content: '饮食禁忌' },
      { type: 'list', items: ['辛辣刺激性食物：辣椒、花椒、大蒜、生姜、芥末等辛辣食物可加重局部炎症和瘙痒，治疗期间应严格避免。', '高糖食物：蛋糕、甜点、含糖饮料、糖果等为念珠菌提供生长所需的"糖分养料"，念珠菌感染者应严格控制。', '酒精类饮品：白酒、啤酒、红酒等可扩张血管、加重局部充血和炎症，且可能与口服抗真菌药发生相互作用。', '海鲜发物（中医角度）：虾、蟹、带鱼等"发物"可能诱发或加重皮肤黏膜炎症，治疗期间建议避免。', '油炸及高脂食物：增加体内湿热，不利于炎症消退。', '咖啡和浓茶：刺激性饮料可能加重瘙痒和不适。'] },
      { type: 'heading', level: 2, content: '一日三餐建议' },
      { type: 'paragraph', content: '早餐：燕麦粥（或小米粥）+ 水煮蛋 + 小番茄。清淡易消化，提供充足蛋白质和维生素。午餐：清蒸鱼 + 蒜蓉西兰花 + 糙米饭。优质蛋白搭配绿色蔬菜，营养均衡不油腻。晚餐：冬瓜排骨汤 + 凉拌黄瓜 + 杂粮馒头。清淡利湿，晚餐不过饱。加餐：新鲜水果（如猕猴桃或苹果）、无糖酸奶（含益生菌有助于维持菌群平衡）。' },
    ],
    faqs: [
      { question: '龟头责期间能吃海鲜吗？', answer: '从中医角度，海鲜多属"发物"，可能加重湿热和炎症。从现代医学角度，如果对海鲜不过敏，适量食用并非绝对禁忌，但建议治疗期间暂时避免，待康复后再逐步恢复。' },
      { question: '喝酸奶对龟头责有帮助吗？', answer: '无糖酸奶中的益生菌（如乳酸杆菌）有助于维持身体正常菌群平衡。对于反复发作的念珠菌感染者，适量食用无糖酸奶可能有一定辅助作用，但不应替代规范的药物治疗。' },
    ],
    relatedArticles: ['guitouze-zhiliao-fangan', 'guitouze-yufang-cuoshi', 'guitouze-bingyin-fenxi'],
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.categorySlug === categorySlug);
}

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getRelatedArticles(slugs: string[]): Article[] {
  return articles.filter((a) => slugs.includes(a.slug));
}

export function getLatestArticles(count: number = 6): Article[] {
  return [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, count);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}